import { PaperProps, Popover, PopoverOrigin } from '@mui/material';
import React from 'react';

type Props = {
    component: React.ReactNode;
    paperProps?: PaperProps;
    getAnchorOrigin?: (anchorEl: HTMLDivElement) => PopoverOrigin;
    transformOrigin?: PopoverOrigin;
    // used to give control over closing Popover to children component
    renderChildren: (closePopover: () => void) => React.ReactNode;
    onClick?: () => void;
};
const SIDEBAR_OFFSET = 16;
const defaultPaperProps: PaperProps = {
    style: { width: '620px', padding: '20px', paddingBottom: '0px' },
};

// default offset to be diplayed along the right border of the sidebar panel from a MenuItem in the sidebar
const defaultGetAnchorOrigin = (anchorEl: Element): PopoverOrigin => ({
    vertical: 'center',
    horizontal: anchorEl?.getBoundingClientRect().width + SIDEBAR_OFFSET,
});

const defaultTransformOrigin: PopoverOrigin = {
    vertical: 'center',
    horizontal: 'left',
};

export const ClickPopover = ({
    component,
    paperProps = defaultPaperProps,
    getAnchorOrigin = defaultGetAnchorOrigin,
    transformOrigin = defaultTransformOrigin,
    renderChildren,
    onClick: onClickProp,
}: Props): React.ReactElement => {
    const [anchorEl, setAnchor] = React.useState<
        (EventTarget & HTMLDivElement) | null
    >(null);
    return (
        <>
            <div
                onClick={(event) => {
                    setAnchor(event.currentTarget);
                    onClickProp?.();
                }}
                role="button"
                tabIndex={-1}
            >
                {component}
            </div>
            {anchorEl && (
                <Popover
                    open={anchorEl !== null}
                    onClose={() => setAnchor(null)}
                    anchorOrigin={getAnchorOrigin(anchorEl)}
                    transformOrigin={transformOrigin}
                    anchorEl={anchorEl}
                    PaperProps={paperProps}
                >
                    {renderChildren(() => setAnchor(null))}
                </Popover>
            )}
        </>
    );
};
